import { styled } from '@mui/material/styles'
import { Divider } from '@mui/material'

export const LightGreyDivider = styled(Divider)(({ theme }) => ({
  backgroundColor: "lightGrey",
  margin: theme.spacing(3.5),
  marginBottom: theme.spacing(3),
  variant:"middle"
}));
